import React, { ReactElement } from "react";
import type { PopoverOrigin } from "@material-ui/core/Popover";

import { ThemePopover } from "./ThemePopover";
import TaskVideoFactory from "./TaskVideoFactory";

export interface PopoverState {
    position: { top: number; left: number };
    transformOrigin: PopoverOrigin;
}

export type TaskRendererFactoryProps =
    | {
        type: "popover";
        taskKey: string;
        popoverState: PopoverState;
        onPopoverClose: () => void;
        onCallback?: () => void;
        saveOnOpen?: boolean;
    }
    | {
        type: "preview";
        taskKey: string;
        videoUrl: string;
    }
    | {
        type: "full";
        taskKey: string;
        videoUrl: string;
        onVideoClose: () => void;
        onTaskComplete: () => void;
    }
    | {
        type: "none";
    };

const TaskRendererFactory = (props: TaskRendererFactoryProps): ReactElement | null => {
    switch (props.type) {
        case "popover": {
            const { taskKey, popoverState, onPopoverClose, onCallback, saveOnOpen } = props as Extract<TaskRendererFactoryProps, { type: "popover" }>;
            return (
                <ThemePopover
                    open={true}
                    taskKey={taskKey}
                    popoverState={popoverState}
                    onClose={onPopoverClose}
                    onCallback={onCallback}
                    saveOnOpen={saveOnOpen ?? true}
                />
            );
        }
        case "preview": {
            const { taskKey, videoUrl } = props as Extract<TaskRendererFactoryProps, { type: "preview" }>;
            return (
                <TaskVideoFactory
                    taskKey={taskKey}
                    videoUrl={videoUrl}
                    isPreview
                />
            );
        }
        case "full": {
            const { taskKey, videoUrl, onVideoClose, onTaskComplete } = props as Extract<TaskRendererFactoryProps, { type: "full" }>;
            return (
                <TaskVideoFactory
                    taskKey={taskKey}
                    videoUrl={videoUrl}
                    isPreview={false}
                    onClose={onVideoClose}
                    onTaskComplete={onTaskComplete}
                />
            );
        }
        case "none":
        default:
            return null;
    }
};

export default TaskRendererFactory;

